import type {
  CreateOrderPayload,
  OrderResponse
} from '@/modules/buy-now/domain/types';
import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';

const { CREATE_NEW_ORDER } = environment;

export async function createBuyNowOrder(
  payload: CreateOrderPayload,
  cartId: string
): Promise<{ data: OrderResponse }> {
  return httpClient.post(CREATE_NEW_ORDER, payload, {
    headers: {
      'x-cart-id': cartId
    }
  });
}
